module.exports = __webpack_public_path__ + "img/event-default.08587685.jpg";